module.exports = __webpack_public_path__ + "media/icon_transaction/bird_1-381f3fbd.png";